import React, { useState } from 'react';
import api from '../services/api';

export default function BoutonPaiementMobileMoney({ fournisseur, montant, onResultat }) {
  const [loading, setLoading] = useState(false);

  async function payer() {
    setLoading(true);
    try {
      const { data } = await api.post('/paiement/mobile-money', {
        fournisseur,
        montant,
        reference: `shopmarega-${Date.now()}`
      });
      onResultat?.(data);
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      onClick={payer}
      disabled={loading}
      className="w-full rounded-2xl border border-gray-200 bg-white px-5 py-4 text-sm font-semibold text-gray-900 hover:bg-gray-50 disabled:opacity-50"
    >
      {loading ? 'Traitement...' : `Payer via ${fournisseur === 'wave' ? 'Wave' : 'Orange Money'}`}
    </button>
  );
}
